import { Vector3 } from 'three';

import { logger } from '@/modules/common/logging/logger';
import { Area } from '@/modules/floorplanDesign/types';

import { IDistconService } from './IDistconService';

export class DistconServiceLogDecorator implements IDistconService {
  private decoree: IDistconService;

  constructor(decoree: IDistconService) {
    this.decoree = decoree;
  }

  activateTool(): void {
    const start = this.logStart('activateTool [in distcon service]');
    this.decoree.activateTool();
    this.logEnd('activateTool [in distcon service]', start);
  }

  cancelTool(): void {
    const start = this.logStart('cancelTool [in distcon service]');
    this.decoree.cancelTool();
    this.logEnd('cancelTool [in distcon service]', start);
  }

  startDistcon(area: Area, clickedPosition: Vector3): void {
    const start = this.logStart('startDistcon');
    this.decoree.startDistcon(area, clickedPosition);
    this.logEnd('startDistcon', start);
  }

  endDistcon(area: Area, clickedPosition: Vector3): void {
    const start = this.logStart('endDistcon');
    this.decoree.endDistcon(area, clickedPosition);
    this.logEnd('endDistcon', start);
  }

  private logStart(methodName: string): number {
    const start: number = performance.now();
    logger.info(`Start -> ${methodName}`);
    return start;
  }

  private logEnd(methodName: string, start: number): void {
    logger.info(`End -> ${methodName} (${(performance.now() - start).toFixed(2)}ms)`);
  }
}
